import React, { createContext, useEffect, useState, useLayoutEffect, useRef, memo } from "react"
import { VarNavInCard as VarNav } from "./../../model/model-variations/VarNav"
import { Route } from "./../../model/model-variations/Route"
import { WatchRoller } from "./../../model/model-variations/WatchRoller"
import { StepList } from "./../../model/model-variations/StepList"
import { FooterInCard as Footer } from "./../../model/model-variations/Footer"
import { Wishlist, NewModel } from "./../../model/model-variations/Wishlist"
import { useWatchVariations, mvSubscribe } from "./../../model/model-variations/context"
import { RollerAnimationProvider } from "./../../model/model-variations/context.roller"
import { Main, Wrapper, SubWrapper, Close, ActionsWrapper, ApplyToAllCTAWrapper, ApplyButton } from "./styles"
import { KILL_ROUTE, RESET_ROUTE, UPDATE_ROUTE, STEPS } from "./../../model/model-variations/constants"
import { Icon } from "components/icon/Icon"
import { useDictionary } from "contexts/Dictionary"
import { useWatchgrid } from "./../context"
import { CardLink } from "./CardLink"
import { Loader } from "./../../model/model-variations/Loader"
import { FocusScope } from "@react-aria/focus"

function setProperty(el, key, value) {
  el?.style?.setProperty?.(key, value)
}

function ApplyCTA({ ctx, onFocusClick }) {
  const { active, entry, route } = useWatchVariations(ctx)
  const rfmain = useRef(null)
  const dictionary = useDictionary()

  function display() {
    //    console.log("bbb ApplyCTA display")
    //    console.log("display", route.get(), active.get())
    let _route = route.get()
    let reveal = !!_route && _route !== UPDATE_ROUTE && _route !== RESET_ROUTE && _route !== KILL_ROUTE
    //    let same = active.get() === entry.get()
    //    rfmain.current?.classList[!same && reveal ? "add" : "remove"]("wv_reveal")
    rfmain.current?.classList[reveal ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("ApplyCTA active", active, display), [])
  useLayoutEffect(() => mvSubscribe("ApplyCTA route", route, display), [])
  useLayoutEffect(() => mvSubscribe("ApplyCTA entry", entry, display, false), [])

  return (
    <button ref={rfmain} className='wv_apply' onClick={onFocusClick}>
      {dictionary.groupedVariationsSelect()}
    </button>
  )
}
/*
function ApplyToAllCTA({ ctx, onFocusClick }) {
  const { active, entry, route } = useWatchVariations(ctx)
  const { wapply, enableApply } = useWatchgrid()
  const rfmain = useRef(null)

  function onClick(e) {
    entry.set(active.get())
    wapply()
  }

  function display(v) {
    console.log("bbb ApplyToAllCTA display", v)
    rfmain.current?.classList[!!v && v !== KILL_ROUTE && v !== UPDATE_ROUTE ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("ApplyCTA route", route, display), [])

  return (
    <ApplyToAllCTAWrapper ref={rfmain}>
      <button onClick={onClick}>
        <span>Apply changes to full grid</span>
      </button>
    </ApplyToAllCTAWrapper>
  )
}
*/
function CloseCTA({ ctx, handleClose }) {
  const { route } = useWatchVariations(ctx)
  const rfmain = useRef(null)
  const dictionary = useDictionary()

  function display(v) {
    //    console.log("bbb CloseCTA display", v)
    rfmain.current?.classList[!!v && v !== KILL_ROUTE && v !== UPDATE_ROUTE ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, display), [])

  return (
    <Close ref={rfmain} aria-label={dictionary.popinClose()} onClick={handleClose}>
      <Icon type='close' size="12" />
    </Close>
  )
}

function useItems(steps, collection, getModel, focus, swapping) {
  const rfitems = useRef(null)

  function clear() {
    rfitems.current = null
  }

  function update() {
    //    console.log("bbb ModelVariationsRoller useItems update")
    const _steps = steps.get()
    if (!_steps) return clear()
    let [_stepindex, _start, ..._items] = _steps.split(",")
    //    alert(_items.slice(1).map(getModel))
    //    _stepindex = +_stepindex
    if (+_stepindex <= 0) {
      swapping.set(_steps)
      focus.set(+_start)
      return clear()
    }
    const unready = _items.map(getModel).filter(v => !v).length
    if (unready) return clear()
    rfitems.current = _items
    swapping.set(_steps)
    focus.set(+_start)
  }

  function onSteps(v) {
    //    console.log("bbb ModelVariationsRoller useItems onSteps", v)
    update()
  }

  function onCollection(v) {
    //    console.log("bbb ModelVariationsRoller useItems onCollection", v)
    update()
  }

  useEffect(() => mvSubscribe("StepList useItems", steps, onSteps), [])
  useEffect(() => mvSubscribe("collection useItems", collection, onCollection), [])

  return rfitems
}

function ModelVariationsRoller({ ctx, rctx, onCoverClick, onFocusClick }) {
  const { steps, collection, getModel, active, swapping } = useWatchVariations(ctx)
  const { focus } = useWatchVariations(rctx)
  const rfitems = useItems(steps, collection, getModel, focus, swapping)

  function onFocus(v) {
    //    console.log("bbb ModelVariationsRoller onFocus", v)
    if (swapping.get() || !rfitems.current || v < 0) return
    active.set(rfitems.current[v])
  }

  useEffect(() => mvSubscribe("StepList focus", focus, onFocus), [])

  return (
    <>
      <StepList ctx={ctx} rctx={rctx} onFocusClick={onFocusClick} attrs={{ tabIndex: -1 }} />
      <WatchRoller ctx={ctx} rctx={rctx} onCoverClick={onCoverClick} />
    </>
  )
}

function SubWrapperContents({ ctx, onFocusClick }) {
  const { selected } = useWatchgrid()
  const { route, incard } = useWatchVariations(ctx)
  const rfmain = useRef(null)
  const pid = incard.replace("/", "_")

  function display(v) {
    //    console.log("bbb SubWrapperContents display", v)
    const state = !!v && v !== RESET_ROUTE && v !== KILL_ROUTE
    //    onResize(state)    
    rfmain.current?.classList[state ? "add" : "remove"]("wv_reveal")
  }
  /*
    function onResize(expand) {
      console.log("bbb SubWrapperContents onResize", expand)
      const h = expand ? rfreveal.current.offsetHeight : 0
      setProperty(rfmain.current, "--subwrapper-reveal", `${h}px`)
    }
  */
  useLayoutEffect(() => mvSubscribe("ModelVariations route", route, display), [])

  return (
    <SubWrapper ref={rfmain}>
      <VarNav ctx={ctx} selected={selected} />
      <Footer ctx={ctx} pid={pid} />
      <ActionsWrapper>
        {/*<ResetCTA ctx={ctx} />*/}
        <ApplyCTA ctx={ctx} onFocusClick={onFocusClick} />
        <Loader ctx={ctx} size={20} color='#ff0000' />
      </ActionsWrapper>
    </SubWrapper>
  )
}
/*
function ButtonApply({ ctx }) {
  const { entry } = useWatchVariations(ctx)
  const { wapply, getModel } = useWatchgrid()
  const ref = useRef()

  function onClick(e) {
    wapply(getModel(entry.get()))
  }

  return (
    <ApplyButton ref={ref} onClick={onClick}>
      {"Apply to all"}
    </ApplyButton>
  )
}
*/
const ModelVariations = memo(({ children, ctx, onFocusClick }) => {
  const { route, active, rfroot, incard, stepindex, entry, reset } = useWatchVariations(ctx)
  const { selected, willapply, similar } = useWatchgrid()
  const rctx = createContext(null)
  const rfwrapper = useRef(null)
  const dictionary = useDictionary()

  function print(v) {
    //    console.log("bbb ModelVariations print", v)
    Array.from({ length: STEPS.length }).map((v, i) => {
      rfroot.current?.classList.remove(`wv_step_${i}`)
    })
    rfroot.current?.classList.add(`wv_step_${v}`)
  }

  //  useEffect(() => mvSubscribe(fetching, init), [])
  useEffect(() => mvSubscribe("", stepindex, print), [])

  function display(v) {
    //    console.log("bbb ModelVariations display", v)
    if (v === UPDATE_ROUTE) return
    //    rfroot.current?.classList[v === KILL_ROUTE ? "add" : "remove"]("wv_kill")
    rfroot.current?.classList[!!v && v !== RESET_ROUTE ? "add" : "remove"]("wv_reveal")
    onActive(active.get())
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations route", route, display), [])

  function onSelection(v) {
    //    console.log("bbb ModelVariations onSelection", v)
    const state = v === incard
    if (v < 0 || state) highlight(-1)
    if (!state && !!route.get()) return close(!v)
    if (state) autoFocus()
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations selected", selected, onSelection, false), [])


  function autoFocus(v) {
    setTimeout(() => {
      const target = rfwrapper.current.querySelector("button")
      if (!target) return
      target.focus()
    }, 40)
  }

  function onActive(v) {
    //    console.log("bbb ModelVariations onActive", v)
    //    updateActive(v)
    if (!v || selected.get() !== incard) return
    //    console.log("act", v)
    willapply.set(v)
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations active", active, onActive, false), [])

  function onClose(e) {
    //    console.log("bbb ModelVariations onClose")
    selected.set(null)
  }

  function close(restoreFocus) {
    //    console.log("bbb ModelVariations close")
    //    fromui.set(true)
    route.set(KILL_ROUTE)
    active.set(entry.get())
    if (!restoreFocus) return
    const target = rfroot.current.querySelector(".wv-show-variations")
    if (!target) return
    setTimeout(target.focus.bind(target), 400)
  }

  function highlight(state) {
    //    console.log("bbb ModelVariations highlight", state)
    const el = rfwrapper.current?.querySelector("a")
    if (!el) return
    el.style.backgroundColor = `rgba(${state ? "0,255" : "255,0"},0,${state < 0 ? "0" : ".05"})`
  }

  function onSimilar(v) {
    if (!v) return
    //    console.log("bbb ModelVariations onSimilar", v)
    const _active = v[incard].toLowerCase()
    //    if (incard === selected.get()) return
    if (active.get() === _active) return
    entry.set(_active)
    reset.set(null)
    route.set(UPDATE_ROUTE)
  }
  useEffect(() => mvSubscribe("ModelVariations similar", similar, onSimilar), [])

  return (
    <Main role='dialog' aria-modal='true' ref={rfroot} className={`wvContents${!!incard ? " wvIncard" : ""}`}>
      <Wrapper ref={rfwrapper}>
        <CloseCTA ctx={ctx} handleClose={onClose} aria-label={dictionary.popinClose()} />
        {/*<ButtonApply ctx={ctx} />*/}
        <Route ctx={ctx} />
        <RollerAnimationProvider Ctx={rctx}>
          <ModelVariationsRoller ctx={ctx} rctx={rctx} onFocusClick={onFocusClick} />
        </RollerAnimationProvider>
        <SubWrapperContents ctx={ctx} onFocusClick={onFocusClick} />
        <NewModel ctx={ctx} />
        <CardLink ctx={ctx} />
        <Wishlist ctx={ctx} />
      </Wrapper>
      {children}
    </Main>
  )
})

export default ModelVariations
